// src/pages/discounts.js
import React from 'react';
import DiscountHero from '../components/discounts/DiscountHero';
import DiscountQuiz from '../components/discounts/DiscountQuiz';
import FinancialAidForm from '../components/discounts/FinancialAidForm';

const DiscountPage = () => {
  return (
    <div className="bg-gray-100">
      <DiscountHero />
      <div className="container mx-auto px-4 py-16 space-y-8">
        <DiscountQuiz />
        <FinancialAidForm />
      </div>
    </div>
  );
};

export default DiscountPage;